import { useRef } from "react";
import ChromaKeyVideo from "../../components/ChromaKeyVideo";

const ChromaPage = () => {
    const videoTalkRef = useRef(null);

    return (
        <div className="avatar">
            <div className="avatar-container">
                <ChromaKeyVideo origin="hospital" chromaColor={{ r: 0, g: 255, b: 0 }} sensitivity={ {r: 218 , g: 130 , b: 79} } isMuted={true} autoPlay={true} isLoop={true} videoRef={videoTalkRef} chromaClass={`avatar-canvas show`} src={"../assets/video-avatar/sample_green.mp4"} />
            </div>
        </div>
    )
}

export default ChromaPage;